<forge-card class="no-padding">
    <forge-scaffold>
        <forge-toolbar slot="header">
            <h2 class="forge-typography--heading2">{{title}}</h2>
            <div slot="end">
                <forge-icon-button *ngIf="selectType === CASCADING" (click)="selectAll(true)">
                    <forge-tooltip type="label" placement="bottom">Select all</forge-tooltip>
                    <forge-icon name="checkbox_multiple_marked"></forge-icon>
                </forge-icon-button>

                <forge-icon-button *ngIf="selectType === CASCADING" (click)="selectAll(false)">
                    <forge-tooltip type="label" placement="bottom">Deselect all</forge-tooltip>
                    <forge-icon name="checkbox_multiple_blank_outline"></forge-icon>
                </forge-icon-button>

                <forge-icon-button (click)="expandAll(true)">
                    <forge-tooltip type="label" placement="bottom">Expand all</forge-tooltip>
                    <forge-icon name="expand"></forge-icon>
                </forge-icon-button>

                <forge-icon-button (click)="expandAll(false)">
                    <forge-tooltip type="label" placement="bottom">Collapse all</forge-tooltip>
                    <forge-icon name="arrow_collapse_vertical"></forge-icon>
                </forge-icon-button>
            </div>
        </forge-toolbar>
        <div slot="body" class="tree-view--body">
            <!-- igx tree does not allow recursively created nodes via templates -->
            <igx-tree #treeView [selection]="selectType" (nodeSelection)="nodeSelection($event)"
                      [ngClass]="selectTypeClass">
                <igx-tree-node *ngFor="let node of nodes" [data]="node" [(selected)]="node.Selected"
                               [(disabled)]="node.Disabled" (click)="nodeClicked(node, $event)">
                    <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: node }"></ng-container>

                    <igx-tree-node *ngFor="let child of node.Children" [data]="child" [(selected)]="child.Selected"
                                   [expanded]="child.Expanded" (click)="nodeClicked(child, $event)">
                        <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: child}"></ng-container>

                        <igx-tree-node *ngFor="let grandChild of child.Children" [data]="grandChild"
                                       [(selected)]="grandChild.Selected" [expanded]="grandChild.Expanded"
                                       (click)="nodeClicked(grandChild, $event)">
                            <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: grandChild}">
                            </ng-container>

                            <igx-tree-node *ngFor="let greatGrandChild of grandChild.Children" [data]="greatGrandChild"
                                           [(selected)]="greatGrandChild.Selected" [expanded]="greatGrandChild.Expanded"
                                           (click)="nodeClicked(greatGrandChild, $event)">
                                <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: greatGrandChild}">
                                </ng-container>

                                <igx-tree-node *ngFor="let greatGreatGrandChild of greatGrandChild.Children"
                                               [data]="greatGreatGrandChild"
                                               [(selected)]="greatGreatGrandChild.Selected"
                                               [expanded]="greatGreatGrandChild.Expanded"
                                               (click)="nodeClicked(greatGreatGrandChild, $event)">
                                    <ng-container
                                                  *ngTemplateOutlet="nodeTemplate; context: { $implicit: greatGreatGrandChild}">
                                    </ng-container>

                                    <igx-tree-node *ngFor="let greatGreatGreatGrandChild of greatGreatGrandChild.Children"
                                                   [data]="greatGreatGreatGrandChild"
                                                   [(selected)]="greatGreatGreatGrandChild.Selected"
                                                   [expanded]="greatGreatGreatGrandChild.Expanded"
                                                   (click)="nodeClicked(greatGreatGreatGrandChild, $event)">
                                        <ng-container
                                                      *ngTemplateOutlet="nodeTemplate; context: { $implicit: greatGreatGreatGrandChild}">
                                        </ng-container>
                                    </igx-tree-node>
                                </igx-tree-node>
                            </igx-tree-node>
                        </igx-tree-node>
                    </igx-tree-node>
                </igx-tree-node>

                <ng-template #nodeTemplate let-data>
                    <div class="tree-node">
                        <forge-icon [name]="data.Icon"></forge-icon>
                        <span class="tree-node--text">{{data.Display}}</span>
                    </div>
                </ng-template>
            </igx-tree>
        </div>
    </forge-scaffold>
</forge-card>